import { gql } from '@apollo/client'

export const MARK_SERIES_AS_PLAYED = gql`
  mutation markSeriesAsPlayed($seriesId: String!) {
    markSeriesAsPlayed(seriesId: $seriesId)
  }
`
